import { connect } from 'react-redux';
import Team from './Team';

export const mapStateToProps = ({ teams }) => ({ teams });

export default connect(mapStateToProps)(Team);
